/**
 * TanStack Form отдаёт ошибки в том виде, в каком их вернул валидатор:
 * для Standard Schema это объекты `{ message }`, для ручных правил — строки.
 * Сообщения наших схем — это i18n-ключи, поэтому наверх уходит ключ, а не текст.
 */
export function firstErrorKey(errors: readonly unknown[] | undefined): string | undefined {
	for (const error of errors ?? []) {
		if (typeof error === "string" && error.length > 0) return error;
		if (error && typeof error === "object" && "message" in error) {
			const message = (error as { message?: unknown }).message;
			if (typeof message === "string" && message.length > 0) return message;
		}
	}
	return undefined;
}
